import React, {useState} from "react";
import {Link} from "react-router-dom";
import {Formik} from "formik";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import clsx from "clsx";
import * as auth from "../../store/ducks/auth.duck";
import {login} from "../../crud/auth.crud";
import {makeStyles, withStyles, TextField} from '@material-ui/core';
import logo from '../../assets/images/royal-flora-logo2x.png';
import * as i18n from "../../../_metronic/ducks/i18n";
import {getLocaleFromLanguageId} from "../../../_metronic/i18n/I18nProvider";

function Login(props) {
    const {intl,setLanguage} = props;
    const [loading, setLoading] = useState(false);
    const [loadingButtonStyle, setLoadingButtonStyle] = useState({
        paddingRight: "2.5rem"
    });
    const CssTextField = withStyles({
        root: {
            "& label.Mui-focused": {
                color: "#c32e95"
            },
            "& .MuiInput-underline:after": {
                borderBottomColor: "#c32e95"
            },
            "& .MuiOutlinedInput-root": {
                "& fieldset": {
                    borderColor: "#9f8a99"
                },
                "&:hover fieldset": {
                    borderColor: "#c32e95"
                },
                "&.Mui-focused fieldset": {
                    borderColor: "#c32e95"
                }
            }
        }
    })(TextField);

    const useStyles = makeStyles(theme => ({
        container: {
            display: 'flex',
            flexWrap: 'wrap',
        },
        textField: {
            marginLeft: theme.spacing(0),
            marginRight: theme.spacing(0),
        },
        dense: {
            marginTop: theme.spacing(2),
        },
        menu: {
            width: 200,
        },
    }));
    const classes = useStyles();

    const enableLoading = () => {
        setLoading(true);
        setLoadingButtonStyle({paddingRight: "3.5rem"});
    };

    const disableLoading = () => {
        setLoading(false);
        setLoadingButtonStyle({paddingRight: "2.5rem"});
    };

    return (
        <>
            {/* <div className="kt-login__form"> */}
            <div className="kt-login__body">
                <div className="kt-login__icon">
                    <img src={logo} alt="Royal Flora Logo"/>
                </div>
                <div className="kt-login__form">
                    <div className="kt-login__title">
                        <h3>
                            {/* https://github.com/formatjs/react-intl/blob/master/docs/Components.md#formattedmessage */}
                            <FormattedMessage id="AUTH.TITLE.MESSAGE"/>
                        </h3>
                    </div>

                    <Formik
                        initialValues={{
                            email: "",
                            password: ""
                        }}
                        validate={values => {
                            const errors = {};

                            if (!values.email) {
                                // https://github.com/formatjs/react-intl/blob/master/docs/API.md#injection-api
                                errors.email = intl.formatMessage({
                                    id: "AUTH.VALIDATION.REQUIRED_FIELD"
                                });
                            } else if (
                                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                            ) {
                                errors.email = intl.formatMessage({
                                    id: "AUTH.VALIDATION.INVALID_EMAIL"
                                });
                            }

                            if (!values.password) {
                                errors.password = intl.formatMessage({
                                    id: "AUTH.VALIDATION.REQUIRED_FIELD"
                                });
                            }

                            return errors;
                        }}
                        onSubmit={(values, {setStatus, setSubmitting}) => {
                            enableLoading();
                            login(values.email, values.password)
                                .then(({data: {data}}) => {
                                    const {access_token} = data;
                                    disableLoading();
                                    props.login(access_token, data);
                                    const lang = getLocaleFromLanguageId(data.language_id);
                                    setLanguage(lang);
                                })
                                .catch((error) => {
                                    const {message, response: {data = {}}} = error;
                                    disableLoading();
                                    setSubmitting(false);
                                    setStatus(data.message || message);
                                });
                        }}
                    >
                        {({
                              values,
                              status,
                              errors,
                              touched,
                              handleChange,
                              handleBlur,
                              handleSubmit,
                              isSubmitting
                          }) => (
                            <form
                                noValidate={true}
                                autoComplete="off"
                                className="kt-form"
                                onSubmit={handleSubmit}
                            >
                                {status ? (
                                    <div role="alert" className="alert alert-danger">
                                        <div className="alert-text">{status}</div>
                                    </div>
                                ) : ''}

                                <div className="form-group">
                                    <CssTextField
                                        className={clsx(classes.textField, classes.dense)}
                                        margin="dense"
                                        variant="outlined"
                                        type="email"
                                        label="Email"
                                        name="email"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.email}
                                        helpertext={touched.email && errors.email}
                                        error={Boolean(touched.email && errors.email)}
                                    />
                                </div>

                                <div className="form-group">
                                    <CssTextField
                                        className={clsx(classes.textField, classes.dense)}
                                        margin="dense"
                                        variant="outlined"
                                        type="password"
                                        label="Password"
                                        name="password"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.password}
                                        helpertext={touched.password && errors.password}
                                        error={Boolean(touched.password && errors.password)}
                                    />
                                </div>

                                <div className="kt-login__actions">
                                    <button
                                        id="kt_login_signin_submit"
                                        type="submit"
                                        disabled={isSubmitting}
                                        className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                                            {
                                                "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": loading
                                            }
                                        )}`}
                                        style={loadingButtonStyle}
                                    >
                                        Login
                                    </button>
                                </div>
                            </form>
                        )}
                    </Formik>
                </div>
                <div className="kt-login__forgot-password-container">
                    <div className="kt-login__actions">
                        <Link
                            to="/auth/forgot-password"
                            className="kt-link kt-login__link-forgot"
                        >
                            <FormattedMessage id="AUTH.BUTTON.FORGOT_PASSWORD"/>
                        </Link>
                    </div>
                </div>
            </div>
        </>
    );
}

export default injectIntl(
    connect(
        null,
        {...auth.actions, ...i18n.actions}
    )(Login)
);
